export default "__VITE_ASSET__25524464__"